/**
 *  @fileOverview  Cookie Policy Cookie
 *
 *  @author Andras Muk <andras.muk@possible.com>
 */

import { cookieHandling } from '../utils/cookie-handling';

const CP_COOKIE = 'cookiepolicy_banner';

class CookiePolicy {
  init() {
    this.initDOMElements();
    if (this.closeButton !== null) {
      this.initBindings();
    }
  }

  initDOMElements() {
    this.cookiePolicyBanner = document.body.querySelector('[data-cookiepolicy]');
    this.closeButton = document.body.querySelector('[data-cookiepolicy-close]');
  }

  initBindings() {
    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeCookiePolicy();
    }, false);
  }

  closeCookiePolicy() {
    cookieHandling.createCookie(CP_COOKIE, 'closed', 365);
    if (this.cookiePolicyBanner !== null) {
      document.body.removeChild(this.cookiePolicyBanner);
    }
  }
}

export const cookiePolicy = new CookiePolicy();



// WEBPACK FOOTER //
// ./src/js/modules/cookiepolicy.js